module.exports = __webpack_public_path__ + "img/menu.e5c03216.png";